import { Entity } from '../../../core/context/entity';

export interface ZoneProps {
    id: string;
    name?: string;
    description: string;
    parentZoneId?: string;
    exposureId?: string;
}

export class Zone extends Entity {
    description: string;
    parentZoneId?: string;
    exposureId?: string;

    constructor({
        id,
        name,
        description,
        parentZoneId,
        exposureId,
    }: ZoneProps) {
        super({ id, name });
        this.description = description;
        this.parentZoneId = parentZoneId;
        this.exposureId = exposureId;
    }
}
